import axios from '../../../axios';
import * as actionTypes from '../actionTypes';
import {updateProfileFail, updateProfileSuccess} from "../profile";


export const loginStart = () => {
    return {
        type: actionTypes.LOGIN_START
    };
};

export const loginSuccess = (token, profile, firstTime) => {
    return {
        type: actionTypes.LOGIN_SUCCESS,
        token: token,
        profile: profile,
        firstTime: firstTime
    };
};

/*export const loginSuccess = (token) => {
    return {
        type: actionTypes.LOGIN_SUCCESS,
        token: token
    };
};*/

export const loginFail = (message) => {
    return {
        type: actionTypes.LOGIN_FAIL,
        message: message
    };
};

export const loginRemoveMsg = () => {
    return {
        type: actionTypes.LOGIN_MSG_REMOVE
    };
};

export const logout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('expirationDate');
    //localStorage.setItem('profile', '5');
    return {
        type: actionTypes.LOGOUT
    };
};

export const firstTimeUpdated = () =>{
    return{
        type: actionTypes.FIRSTTIMEUPDATED
    }
};


export const checkLoginTimeout = (expirationTime) => {
    return dispatch => {
        setTimeout(() => {
            dispatch(logout());
        }, expirationTime * 1000);
    };
};

export const login = (email, password) => {
    return dispatch => {
        dispatch(loginStart());
        const loginData = {
            email: email,
            password: password
        };

        const language = localStorage.getItem('language');
        axios.post('user/signin', loginData, {headers: {"language": language}})
            .then(response => {
                const expirationDate = new Date(new Date().getTime() + response.data.expiresIn * 1000);
                if (response.data.status === 1) {
                    localStorage.setItem('token', response.data.token);
                    localStorage.setItem('expirationDate', expirationDate);
                    //localStorage.setItem('profile', response.data.profile);
                    //localStorage.setItem('responseData', response.data);
                    //console.log("response ---->>> " + JSON.stringify(response));
                    //console.log("response.data ------>>>" + JSON.stringify(response.data));
                    //console.log("response.data.profile ------>>" + response.data.profile);
                    //console.log("profile ------->> " + profile);
                    //dispatch(loginSuccess(response.data.token, response.data.profile));
                    //dispatch(loginSuccess(response.data.token));
                    dispatch(checkLoginTimeout(response.data.expiresIn));
                    dispatch(loginSuccess(response.data.token, response.data.profile, response.data.firstTime));
                } else {
                    dispatch(loginFail(response.data.message));
                }
            })
            .catch(err => {
                dispatch(loginFail());
                console.log(err);
            });
    };
};

export const loginCheckState = () => {
    return dispatch => {
        const token = localStorage.getItem('token');
        if (!token) {
            dispatch(logout());
        }
        else {
            const token = 'Bearer ' + localStorage.getItem('token');
            const expirationDate = new Date(localStorage.getItem('expirationDate'));
            axios.get('user/decoded/', { headers: { "Authorization": token } })
                .then(response => {
                    //console.log("response ---->>> " + JSON.stringify(response));
                    //console.log("response.data ---->>>" + JSON.stringify(response.data));
                    //console.log("response.data.profile ---->>>" + response.data.profile);
                    if (expirationDate <= new Date()) {
                        dispatch(logout());
                    }
                    else {
                        dispatch(loginSuccess(token, response.data.profile, response.data.firstTime));
                        dispatch(checkLoginTimeout((expirationDate.getTime() - new Date().getTime()) / 1000));
                    }
                })
                .catch(err => {
                    console.log(err);
                });


            }
        };
};

export const firstTimeChange = () => {

    return dispatch =>{
/*        const token = 'Bearer ' + localStorage.getItem('token');
        console.log("token----->"  + token);
        const options = {
            method: 'POST',
            headers:  { "authorization": token},
            url: 'user/updateFirstTime'
        };
        return axios(options);*/

        const token = 'Bearer ' + localStorage.getItem('token');
        axios.post('user/updateFirstTime', null, { headers: {"authorization": token}})
            .then(response => {
                dispatch(firstTimeUpdated());
                console.log("firstTimeChange");
            })
            .catch(err => {
                console.log(err);
            });
    };
};



/*export const loginCheckState = () => {
    return dispatch => {
        const token = localStorage.getItem('token');
        const profile = localStorage.getItem('profile');
        //const profileCheck = this.profile;
        //console.log("profileCheck ------>>" + profileCheck);
        if (!token) {
            dispatch(logout());
        } else {
            const expirationDate = new Date(localStorage.getItem('expirationDate'));
            if (expirationDate <= new Date()) {
                dispatch(logout());
            } else {
                dispatch(loginSuccess(token, profile));
                //dispatch(loginSuccess(token));
                dispatch(checkLoginTimeout((expirationDate.getTime() - new Date().getTime()) / 1000));
            }
        }
    };
};*/






// WEBPACK FOOTER //
// ./src/store/actions/auth/login.js